fx.ns("models", class PhotoAlbum extends models.Photo {

	constructor(data)
	{
		super(data);
	}

    get propertiesNotStorable()
    {
        return ["thumb", "url", "light_url", "caption"];
    }
});